enum TenantSelectionTestIds {
  TENANT_SELECTION_DIALOG = 'tenantSelectionDialog',
  TENANT_SELECTION_OPTIONS = 'tenantSelectionOptions'
}

export default TenantSelectionTestIds
